export default __webpack_public_path__ + "static/1-3495e28a13c2edcb5137b87c4a886dad.png";